import appSelectors from 'App/duck/selectors'
import clubCardSelectors from 'features/account/club-card/duck/selectors'

import settingsSelectors from '../settings/duck/selectors'

export const PAGE_IDS = {
  account: 'account',
  addressBook: 'addressBook',
  purchases: 'purchases',
  purchasesKlarna: 'purchasesKlarna',
  settings: 'personalSettings',
  pointsHistory: 'pointsHistory',
  inviteFriend: 'inviteAFriend',
  inviteFriendInfo: 'inviteAFriendInfo',
  alternativeIds: 'alternativeIds',
  digitalStylistLandingPage: 'DIGITAL STYLIST LANDING PAGE',
  digitalStylistQuizLandingPage: 'DIGITAL STYLIST QUIZ LANDING PAGE',
  digitalStylistQuizPage: 'DIGITAL STYLIST QUIZ PAGE',
  digitalStylistQuizEndPage: 'DIGITAL STYLIST QUIZ END PAGE',
  digitalStylistResultPage: 'DIGITAL STYLIST RESULT PAGE',
  digitalStylistEditorialPage: 'DIGITAL STYLIST EDITORIAL PAGE',
  deleteAccountPage: 'deleteAccount',
  onlineOrderDetails: 'onlineOrder',
  storeOrderDetails: 'inStorePurchase',
  paymentsDetails: 'paymentDetails',
  challengesPage: 'challengesPage',
  helpus: 'helpus',
  viewallrewards: 'viewallrewards',
}

const getAccountTrackingData = (state): any => {
  const data = {
    category_id: 'myAccount',
    category_path: appSelectors.getSsiContextPath(state),
    customer_bpid: appSelectors.getUserBpid(state),
    customer_id: appSelectors.getUserId(state),
    customer_city: appSelectors.getUserCity(state),
    customer_country: appSelectors.getUserCountryCode(state),
    customer_email: appSelectors.getUserEmail(state),
    customer_state: appSelectors.getUserState(state),
    customer_zip: appSelectors.getUserPostalCode(state),
    customer_fashion_news:
      settingsSelectors.getNewsSubscription(state) ||
      appSelectors.getIsUserSubscribedToFashionNews(state),
    customer_loyalty_level: appSelectors.getCustomerLoyaltyLevel(state),
    customer_has_children: appSelectors.getUserHasChildren(state),
    customer_status: appSelectors.getUserStatus(state),
    customer_club_member: appSelectors.getUserIsFullMember(state),
    customer_club_level: `tier ${clubCardSelectors.getCurrentTier(state)}`,
    customer_fashion_news_optin: appSelectors.getEmailConfirmationState(state),
  }
  return data
}

export default getAccountTrackingData
